const excluded_once = [
  ["2023-12-01", "2024-04-01"],
];

const excluded_always = [
  ["01-01", "01-15"],
  ["07-01", "07-31"],
  ["08-10", "08-25"],
  ["12-15", "12-31"],
];

const tolerance_days = 45;

// Add tolerance
let available_date = addDays(new Date(), tolerance_days);
available_date.setHours(0, 0, 0, 0);

// Find the earliest available date
while (
  isExcludedAlways(available_date, excluded_always) ||
  isExcludedOnce(available_date, excluded_once)
) {
  available_date = addDays(available_date, 1);
}

function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function stringToDate(string) {
  const [year, month, day] = string.split("-");
  return new Date(+year, +month - 1, +day);
}

function isInRange(date, [start, end]) {
  date.getTime();
  start = stringToDate(start).getTime();
  end = stringToDate(end).getTime();
  return date >= start && date <= end;
}

function isExcludedAlways(date, excluded) {
  const year = date.getFullYear();
  return excluded.some(([start, end]) => {
    const range = [`${year}-${start}`, `${year}-${end}`];
    return isInRange(date, range);
  });
}

function isExcludedOnce(date, excluded) {
  return excluded.some((range) => isInRange(date, range));
}

window.addEventListener("DOMContentLoaded", function () {
  const el = document.getElementById("availability");

  if (!el) return;

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  el.innerHTML = `${months[available_date.getMonth()]} ${available_date.getFullYear()}`;
});
